import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode
} from 'react';

interface TopicContentContextType {
  heroContentIds: string[];
  setHeroContentIds: (ids: string[]) => void;
}

const TopicContentContext = createContext<TopicContentContextType | undefined>(
  undefined
);

export function TopicContentProvider({ children }: { children: ReactNode }) {
  const [heroContentIds, setHeroContentIds] = useState<string[]>([]);

  const memoizedSetHeroContentIds = useCallback((ids: string[]) => {
    setHeroContentIds(ids);
  }, []);

  return (
    <TopicContentContext.Provider
      value={{ heroContentIds, setHeroContentIds: memoizedSetHeroContentIds }}
    >
      {children}
    </TopicContentContext.Provider>
  );
}

export function useTopicContent() {
  const context = useContext(TopicContentContext);
  if (context === undefined) {
    throw new Error(
      'useTopicContent must be used within a TopicContentProvider'
    );
  }
  return context;
}
